export default __webpack_public_path__ + "static/media/DOST.faf21d51.png";